import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeNumber'
})
export class SafeNumberPipe implements PipeTransform {

  transform(value: number | string | null | undefined): string {
    // Si el valor es null, undefined, o string vacío, retornar guión
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    // Si es string, intentar parsear (limpiando $ y comas si existen)
    let numValue: number;
    if (typeof value === 'string') {
      const cleaned = value.replace(/\$/g, '').replace(/,/g, '').trim();
      numValue = parseFloat(cleaned);
    } else {
      numValue = value;
    }
    
    // Si después de parsear es NaN, retornar guión
    if (isNaN(numValue)) {
      return '-';
    }

    // Si es exactamente 0, mostrar guión
    if (numValue === 0) {
      return '-';
    }

    // Formatear usando 2 decimales (incluye negativos y otros valores)
    return numValue.toFixed(2);
  }
}
